import React, { useState } from "react";
import "../../styles/components/ToolBarLeftPanel.scss";
import { useTranslation } from "react-i18next";
import ScrollbarISI from "../../images/ScrollISI.svg";
import RefFootnotes from "../../images/RefFootnotes.svg";
import warning from "../../images/warning.svg";

import ClearText from "../../images/ClearText.svg";

import {
  ADDHEADING,
  SCROLLBAR,
  scrollbar,
  REFERENCE,
  FOOTNOTES,
} from "../../Uitls/ComponentType";
import forwardArrow2 from "../../images/ForwardArrow2.svg";
const ScrollBarWindow = (props) => {
  const { handleCloseElement, getLayerDetails } = props;
  const [searchInputValue, setSearchInputValue] = useState("");
  const { t } = useTranslation();

  const handleChangeSearch = (event) => {
    setSearchInputValue(event.target.value);
  };
  const isDraggable =
    (!props?.editComponent && !props?.isReferenceFootnotes) ||
    (props?.editComponent && !props?.isReferenceFootnotesScrollbar);
  return (
    <>
      <div className="textWindow">
        <div className="addTextscroll">
          <div
            style={{
              backgroundImage: `url(${ScrollbarISI})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              height: "62px",
              width: "228px",
              marginBottom: "18px",
              cursor: "pointer",
            }}
            draggable={true}
            onDragStart={(e) => {
              getLayerDetails(e.target.id, SCROLLBAR);
            }}
            onDragEnd={() => {
              getLayerDetails("", "");
            }}
          />

          {!props?.isOneTimeAsset && (
            <div
              style={{
                backgroundImage: `url(${RefFootnotes})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                height: "58px",
                width: "228px",
                cursor: isDraggable ? "pointer" : "auto",
              }}
              draggable={isDraggable}
              onDragStart={(e) => {
                getLayerDetails(e.target.id, REFERENCE);
                // getLayerDetails(e.target.id, FOOTNOTES);
              }}
              onDragEnd={() => {
                getLayerDetails("", "");
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ScrollBarWindow;
